import { LoadingContainer, ModelViewer } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useGetCaseTypeById } from 'core/types'

const CaseType = () => {
  const { caseTypeId } = useParams<{ caseTypeId?: string }>()

  const { data: caseType, isLoading } = useGetCaseTypeById({ caseTypeId })

  return (
    <LoadingContainer loading={isLoading}>
      <Page variant='full'>
        <ModelViewer json={caseType} />
      </Page>
    </LoadingContainer>
  )
}

export default CaseType
